import { coerceArray } from '@angular/cdk/coercion';
import { Injectable, Type } from '@angular/core';
import { ArrayHelper } from 'apps/idl/src/helpers/arrayHelper';
import { DateHelper } from 'apps/idl/src/helpers/dateHelper';
import { GuidHelper } from 'apps/idl/src/helpers/guidHelper';
import { IdHelper } from 'apps/idl/src/helpers/idHelper';
import { MapHelper } from 'apps/idl/src/helpers/mapHelper';
import { NumberHelper } from 'apps/idl/src/helpers/numberHelper';
import { ObjectHelper } from 'apps/idl/src/helpers/objectHelper';
import { StringHelper } from 'apps/idl/src/helpers/stringHelper';
import { TarifHelper } from 'apps/idl/src/helpers/tarifHelper';
import { ConfigData, IStoreDocument } from 'apps/idl/src/model';
import { Acte } from 'apps/idl/src/model/Acte';
import { EMajorationType } from 'apps/idl/src/model/EMajorationType';
import { EPathologie } from 'apps/idl/src/model/EPathologies';
import { EPrefix } from 'apps/idl/src/model/EPrefix';
import { ESortOrder } from 'apps/idl/src/model/ESortOrder';
import { IActeDocumentByLc } from 'apps/idl/src/model/IActeDocumentByLc';
import { IDeplacementByProfession } from 'apps/idl/src/model/IDeplacementByProfession';
import { ISeance } from 'apps/idl/src/model/ISeance';
import { ITarifLettreCle } from 'apps/idl/src/model/ITarifLettreCle';
import { Majoration } from 'apps/idl/src/model/Majoration';
import { Traitement } from 'apps/idl/src/model/Traitement';
import { UserData } from 'apps/idl/src/model/application/UserData';
import { IGroupMember } from 'apps/idl/src/model/contacts/IGroupMember';
import { ETimetablePattern } from 'apps/idl/src/model/date/ETimetablePattern';
import { EAvatarSize } from 'apps/idl/src/model/picture/EAvatarSize';
import { IAvatar } from 'apps/idl/src/model/picture/IAvatar';
import { EDatabaseRole } from 'apps/idl/src/model/store/EDatabaseRole';
import { IDataSource } from 'apps/idl/src/model/store/IDataSource';
import { ActesService } from 'apps/idl/src/modules/actes/actes.service';
import { ECotationAction } from 'apps/idl/src/modules/actes/model/ECotationAction';
import { ECotationConditionPattern } from 'apps/idl/src/modules/actes/model/ECotationConditionPattern';
import { ICotationRule } from 'apps/idl/src/modules/actes/model/ICotationRule';
import { ICotationRuleDocument } from 'apps/idl/src/modules/actes/model/ICotationRuleDocument';
import { ICotationRuleLimit } from 'apps/idl/src/modules/actes/model/ICotationRuleLimit';
import { ActeOccurrenceComparator } from 'apps/idl/src/modules/actes/model/acte-occurrence-comparator';
import { ActeOccurrenceDateTimeComparator } from 'apps/idl/src/modules/actes/model/acte-occurrence-date-time-comparator';
import { ActeOccurrenceIntervenantsComparator } from 'apps/idl/src/modules/actes/model/acte-occurrence-intervenants-comparator';
import { ActeOccurrenceRangeComparator } from 'apps/idl/src/modules/actes/model/acte-occurrence-range-comparator';
import { Constraint } from 'apps/idl/src/modules/actes/model/constraint';
import { IActeOccurrence } from 'apps/idl/src/modules/actes/model/iacte-occurrence';
import { IntervenantConstraint } from 'apps/idl/src/modules/actes/model/intervenant-constraint';
import { IMinMaxDates } from 'apps/idl/src/modules/date/model/IMinMaxDates';
import { EUTCAccuracy } from 'apps/idl/src/modules/date/model/eutcaccuracy.enum';
import { DayRepetition } from 'apps/idl/src/modules/event-markers/models/day-repetition';
import { IDayRepetition } from 'apps/idl/src/modules/event-markers/models/iday-repetition';
import { C_RANGE_REPETITION_TYPE, RangeRepetition } from 'apps/idl/src/modules/event-markers/models/range-repetition';
import { Recurrence } from 'apps/idl/src/modules/event-markers/models/recurrence';
import { EIdlPrestationLineCategory } from 'apps/idl/src/modules/facturation/models/eidl-prestation-line-category.enum';
import { IdlPrestation } from 'apps/idl/src/modules/facturation/models/idl-prestation';
import { IdlPrestationLine } from 'apps/idl/src/modules/facturation/models/idl-prestation-line';
import { IIdlPrestationIdBuilderParams } from 'apps/idl/src/modules/facturation/models/iidl-prestation-id-builder-params';
import { IIdlPrestationLine } from 'apps/idl/src/modules/facturation/models/iidl-prestation-line';
import { ILogSource } from 'apps/idl/src/modules/logger/models/ILogSource';
import { LogActionHandler } from 'apps/idl/src/modules/logger/models/log-action-handler';
import { LoggerService } from 'apps/idl/src/modules/logger/services/logger.service';
import { Observation } from 'apps/idl/src/modules/observations/models/observation';
import { ObservationsService } from 'apps/idl/src/modules/observations/observations.service';
import { IPatient } from 'apps/idl/src/modules/patients/model/IPatient';
import { PatientsService } from 'apps/idl/src/modules/patients/services/patients.service';
import { PerformanceManager } from 'apps/idl/src/modules/performance/PerformanceManager';
import { IPlanningRH } from 'apps/idl/src/modules/planning-rh/model/IPlanningRH';
import { IDaySectorAffectationsMap } from 'apps/idl/src/modules/planning-rh/model/iday-sector-affectations-map ';
import { PlanningRHService } from 'apps/idl/src/modules/planning-rh/services/planning-rh.service';
import { EPrestationStatus } from 'apps/idl/src/modules/prestation/models/eprestation-status.enum';
import { PrestationService } from 'apps/idl/src/modules/prestation/services/prestation.service';
import { EChoiceFilter } from 'apps/idl/src/modules/seances/choose-seances-to-modify-modal/EChoiceFilter';
import { SeancesHelper } from 'apps/idl/src/modules/seances/helpers/seances.helper';
import { IChooseSeancesToModifiyResponse } from 'apps/idl/src/modules/seances/model/ichoose-seances-to-modifiy-response';
import { EIndemniteType } from 'apps/idl/src/modules/traitement/model/EIndemniteType';
import { Indemnite } from 'apps/idl/src/modules/traitement/model/Indemnite';
import { ExtraCharge } from 'apps/idl/src/modules/traitement/model/extra-charge';
import { IRange } from 'apps/idl/src/modules/utils/models/models/irange';
import { DestroyableServiceBase } from 'apps/idl/src/modules/utils/services/destroyable-service-base';
import { IdlApplicationService } from 'apps/idl/src/services/idlApplicationService.service';
import { IndemniteService } from 'apps/idl/src/services/indemnite.service';
import { SeanceService } from 'apps/idl/src/services/seance.service';
import { ContactsService } from 'apps/idl/src/services/security';
import { ApplicationService } from 'apps/idl/src/services/security/application.service';
import { Store } from 'apps/idl/src/services/store.service';
import { findLast } from 'lodash';
import { Observable, defer, forkJoin, of, throwError } from 'rxjs';
import { catchError, map, mapTo, mergeMap, switchMap, tap } from 'rxjs/operators';
import { EStatusSeance } from '../../../../model/EStatusSeance';
import { Deplacement } from '../../../../modules/traitement/model/Deplacement';
import { C_PREFIX_PATIENT, C_PREFIX_TRAITEMENT } from '../../../anakin.constants';
import { SeanceKey } from '../../../models/SeanceKey';
import { StoredSeance as Seance, StoredSeance } from '../../../models/StoredSeance';
import { EEtatActe } from '../enums/EEtatActe';
import { SeanceService as SeanceServiceAnakin } from './seance.service';
import { TAX_ALLOWANCE_MESSAGES } from '../../../shared/tax-allowance.constants';
import { PACKAGE_IDS } from '../../../shared/package.constants';
import { ACT_IDS } from '../../../shared/acts.constants';

@Injectable({ providedIn: "root" })
export class SeancesGeneratorService extends DestroyableServiceBase implements ILogSource {

	private isvcApplication: IdlApplicationService;

	/** @implements */
	public readonly logSourceId = "IDL.SEANCE.S::";
	/** @implements */
	public readonly logActionHandler = new LogActionHandler(this);

	public static readonly emptyAvatar: IAvatar = {
		size: EAvatarSize.big,
		icon: "help",
		color: "danger",
		useIconAsDefaultFallback: true,
		text: "Non affecté"
	};

	constructor(
		private isvcStore: Store,
		private isvcPlanningRH: PlanningRHService,
		private isvcPatients: PatientsService,
		private isvcIndemnite: IndemniteService,
		private isvcActes: ActesService,
		private svcPrestation: PrestationService,
		private svcSeance: SeanceServiceAnakin,
		private svcObservation: ObservationsService,
		/** @implements */
		public readonly isvcLogger: LoggerService,
		psvcApplication: ApplicationService) {
		super();
		this.isvcApplication = psvcApplication as IdlApplicationService;
	}

	public saveSeances(traitement: Traitement, patient: IPatient, existingSeances?: StoredSeance[]): Observable<Boolean> {
		const databaseId = ArrayHelper.getFirstElement(this.isvcStore.getDatabasesIdsByRole(EDatabaseRole.workspace));

		return this.generateSeances(traitement, patient, true, true).pipe(
			mergeMap((seances: ISeance[]) => {
				const saveSeanceObservables = seances.map((seance: ISeance) => {

					// Si la séance existe déjà dans existingSeances alors on ne l'a crée pas
					if (existingSeances && existingSeances.some((existingSeance: StoredSeance) => new Date(existingSeance.startDate).getTime() === seance.startDate.getTime())) {
						return of(null);
					}

					const storedSeance: StoredSeance = { ...seance } as StoredSeance;
					const key: SeanceKey = new SeanceKey(seance.traitementId, seance.patientId);
					storedSeance._id = key.toString();
					return this.isvcStore.put(storedSeance, databaseId);
				});
				// On ne save que les séances qui ne sont pas null
				return forkJoin(saveSeanceObservables.filter(saveSeance => !!saveSeance));
			}),
			map(() => true),
			catchError(() => of(false))
		);
	}

	public saveSeancesBulk(traitement: Traitement, patient: IPatient, existingSeances?: StoredSeance[]): Observable<Boolean> {
		const databaseId = ArrayHelper.getFirstElement(this.isvcStore.getDatabasesIdsByRole(EDatabaseRole.workspace));

		const isSameTimeOrMoment = (newSeance: StoredSeance, existingSeance: StoredSeance): boolean => {
			const momentNewSeance: IDayRepetition = newSeance.moment;
			const momentExistingSeance: IDayRepetition = existingSeance.moment;
			if (new Date(existingSeance.startDate).toDateString() !== new Date(newSeance.startDate).toDateString()) return false;
			if (momentNewSeance?.type === C_RANGE_REPETITION_TYPE && momentExistingSeance?.type === C_RANGE_REPETITION_TYPE) {
				const hoursNewSeance: number = +momentNewSeance.from.hours;
				const hoursExistingSeance: number = +momentExistingSeance.from.hours;
				// Issue 2708: changement de l'heure du matin de 6h à 8h
				if (hoursExistingSeance === 6) return hoursNewSeance === 8 || hoursNewSeance === 6;
				return hoursNewSeance === hoursExistingSeance;
			}
			return new Date(existingSeance.startDate).getTime() === newSeance.startDate.getTime()
		}

		return this.generateSeances(traitement, patient, true, true).pipe(
			mergeMap((seances: StoredSeance[]) => {
				const seancesToSave: StoredSeance[] = seances
					.filter((seance: StoredSeance) => {
						// Filtre les séances existantes
						return !(
							existingSeances &&
							existingSeances.some(
								(existingSeance: StoredSeance) => !existingSeance.isManuel && isSameTimeOrMoment(seance, existingSeance))
						);
					})
					.map((seance: StoredSeance) => {
						const key: SeanceKey = new SeanceKey(seance.traitementId, seance.patientId);
						seance._id = key.toString();
						return seance;
					});

				if (existingSeances && Array.isArray(existingSeances) && ArrayHelper.hasElements(existingSeances)) {
					// Parmis les seances existantes réalisées, on applique le paramètre "Prise en charge 100% CPAM" aux actes correspondants
					existingSeances.forEach((seance: StoredSeance) => {
						if (seance.status !== EStatusSeance.done) return;
						let isUpdated: boolean = false;
						seance.actes.forEach((acteSeance: Acte) => {
							const acteFound: Acte = traitement.actes.find((acteTraitement: Acte) => acteSeance.guid === acteTraitement.guid);
							if (!acteFound) return;
							if (acteFound.isAldExonerante !== acteSeance.isAldExonerante) {
								acteSeance.isAldExonerante = acteFound.isAldExonerante;
								isUpdated = true;
							}
						})
						if (isUpdated) seancesToSave.push(seance);
					});
				}

				// On ne save que les séances qui ne sont pas null
				return this.isvcStore.putMultipleDocuments(seancesToSave, databaseId);
			}),
			map(() => true),
			catchError(() => of(false))
		);
	}

	//#region Séances

	/** Parcourt les actes ajoutés au traitement et détermine les dates des actes pour les séances. */
	private createTraitementActeOccurrences(
		poTraitement: Traitement,
		poAffectationsBySectorAndDays?: IDaySectorAffectationsMap,
		psSectorId?: string,
		poRange?: IRange<Date>
	): Observable<IActeOccurrence[]> {
		const loTraitementActesOccurrencesByDay: Map<number, Map<Acte, IActeOccurrence[]>> = this.generateActesOccurrences(poTraitement, psSectorId);
		let lbAllIntervenantsLocked = true;

		const loPerformanceManager = new PerformanceManager;
		loPerformanceManager.markStart();

		loTraitementActesOccurrencesByDay.forEach((poActeOccurrencesByActe: Map<Acte, IActeOccurrence[]>, pnDayIndex: number) => {
			const laDayActeOccurrences: IActeOccurrence[] = ArrayHelper.flat(MapHelper.valuesToArray(poActeOccurrencesByActe));
			if (ArrayHelper.hasElements(laDayActeOccurrences)) {
				let lbHasToReexecute = false;
				do {
					lbHasToReexecute = this.applyRangeRecurrence(laDayActeOccurrences); // On applique les récurrences de range avant l'application du planning pour que les itérations soient sur le bon horaire.

					laDayActeOccurrences.forEach((poActeOccurrence: IActeOccurrence, pnActeIndex: number, paDayActeOccurrences: IActeOccurrence[]) => {
						const lbHasExecutedConstraint: boolean = this.execActeConstraints(poActeOccurrence);

						if (lbHasExecutedConstraint) { // Si une contrainte a été exécutée
							const lnNewDayIndex: number = DateHelper.diffDays(poActeOccurrence.date, poTraitement.beginDate);
							if (lnNewDayIndex !== pnDayIndex) { // Si l'occurence a changée de jour, alors on la déplace de groupe dans la Map pour rester cohérent
								ArrayHelper.removeElementByIndex(paDayActeOccurrences, pnActeIndex);
								this.moveActeOccurrenceToNewDay(loTraitementActesOccurrencesByDay, lnNewDayIndex, poActeOccurrence, poActeOccurrencesByActe);
							}
						}

						lbHasToReexecute = lbHasExecutedConstraint || lbHasToReexecute;
						if (lbAllIntervenantsLocked)
							lbAllIntervenantsLocked = poActeOccurrence.areIntervenantsLocked;
					});

				} while (lbHasToReexecute); // Si il y a une modification au niveau de l'application des contraintes ou des plage de date on recommence.
			}
		});

		console.debug(`${this.logSourceId}Application des contraintes et plages horaires en ${loPerformanceManager.markEnd().measure()}ms.`);

		const laActeOccurrences: IActeOccurrence[] = [];
		let lnMinIndex: number, lnMaxIndex: number;

		loTraitementActesOccurrencesByDay.forEach((poActeOccurrencesByActe: Map<Acte, IActeOccurrence[]>, pnDayIndex: number) => {
			if (poActeOccurrencesByActe.size === 0) // Si pas d'éléments dans la journée on skip
				return;

			if (lnMaxIndex === undefined || pnDayIndex > lnMaxIndex)
				lnMaxIndex = pnDayIndex;
			if (lnMinIndex === undefined || pnDayIndex < lnMinIndex)
				lnMinIndex = pnDayIndex;

			poActeOccurrencesByActe.forEach((paActeOccurrences: IActeOccurrence[], poActe: Acte) => {
				if (ArrayHelper.hasElements(paActeOccurrences)) {
					// Si l'acte à une date de fin antérieure à la date d'interruption du traitement, on utilise la date de fin de l'acte, sinon on utilise celle du traitement.
					let ldEndDate: Date = poActe.endDate && (!poTraitement.breakDate || DateHelper.compareTwoDates(poActe.endDate, poTraitement.breakDate) < 0) ? poActe.endDate : poTraitement.breakDate;
					if (!ldEndDate || (poRange?.to && DateHelper.compareTwoDates(poRange?.to, ldEndDate) < 0))
						ldEndDate = poRange?.to;

					let ldStartDate: Date = poActe.startDate && (!poTraitement.beginDate || DateHelper.compareTwoDates(poActe.startDate, poTraitement.beginDate) < 0) ? poActe.startDate : poTraitement.beginDate;
					if (!ldStartDate || (poRange?.from && DateHelper.compareTwoDates(poRange?.from, ldStartDate) > 0))
						ldStartDate = poRange?.from;

					const lnRangeEndIndex: number = ldEndDate ? DateHelper.diffDays(ldEndDate, poTraitement.beginDate) : undefined;
					const lnRangeStartIndex: number = ldStartDate ? DateHelper.diffDays(ldStartDate, poTraitement.beginDate) : undefined;

					if (NumberHelper.isInRange(pnDayIndex, { from: lnRangeStartIndex, to: lnRangeEndIndex }))
						laActeOccurrences.push(...paActeOccurrences);
				}
			});
		});

		poTraitement.beginDate = DateHelper.addDays(poTraitement.beginDate, lnMinIndex ?? 0);
		poTraitement.endDate = DateHelper.addDays(poTraitement.beginDate, lnMaxIndex ?? 0);

		if (lbAllIntervenantsLocked)
			return of(laActeOccurrences);

		// Si un secteur est passé, même vide, on laisse passer.
		return defer(() => !ObjectHelper.isDefined(psSectorId) ? this.isvcPatients.getPatientSectorId(poTraitement.patientId) : of(psSectorId)).pipe(
			mergeMap((psResultSectorId: string) => {
				const loResult: IMinMaxDates = DateHelper.getMinAndMaxDates(laActeOccurrences.map((poActeOccurrence: IActeOccurrence) => poActeOccurrence.date));
				return defer(() => ObjectHelper.isDefined(poAffectationsBySectorAndDays) ?
					of(poAffectationsBySectorAndDays) :
					this.isvcPlanningRH.getPlannings(loResult.min, loResult.max).pipe(map((paPlannings: IPlanningRH[]) => PlanningRHService.groupPlanningsBySectorAndDays(paPlannings)))
				).pipe(
					map((poResult: IDaySectorAffectationsMap) => {
						laActeOccurrences.forEach((poActeOccurrence: IActeOccurrence) => {
							if (poResult.size > 0) {
								if (poActeOccurrence.acte.usePlanning && !poActeOccurrence.areIntervenantsLocked) {
									const laIntervenantIds: string[] =
										PlanningRHService.getIntervenantByAffectationsGroupedBySectorAndDays(poResult, poActeOccurrence.date, psResultSectorId);

									if (ArrayHelper.hasElements(laIntervenantIds)) {
										poActeOccurrence.intervenantIds = laIntervenantIds;
										poActeOccurrence.areIntervenantsLocked = true;
									}
								}
							}

							if (!poActeOccurrence.areIntervenantsLocked && !StringHelper.isBlank(psResultSectorId))
								poActeOccurrence.intervenantIds = [psResultSectorId];
						});

						return laActeOccurrences;
					})
				);
			})
		);
	}

	private moveActeOccurrenceToNewDay(
		poTraitementActesOccurrencesByDay: Map<number, Map<Acte, IActeOccurrence[]>>,
		pnNewDayIndex: number,
		poActeOccurrence: IActeOccurrence,
		poActeOccurrencesByActe: Map<Acte, IActeOccurrence[]>
	): void {
		const loNewDayActeOccurrencesByActe: Map<Acte, IActeOccurrence[]> = poTraitementActesOccurrencesByDay.get(pnNewDayIndex) ?? new Map;
		const laNewDayActeOccurrences: IActeOccurrence[] = loNewDayActeOccurrencesByActe.get(poActeOccurrence.acte) ?? [];

		const laActeOccurrences: IActeOccurrence[] = poActeOccurrencesByActe.get(poActeOccurrence.acte);
		laNewDayActeOccurrences.push(ArrayHelper.removeElement(laActeOccurrences, poActeOccurrence));

		if (!ArrayHelper.hasElements(laActeOccurrences)) // Si il n'y a plus d'occurrences pour l'acte dans la journée, on peut supprimer l'entré pour l'acte dans la map du jour
			poActeOccurrencesByActe.delete(poActeOccurrence.acte);

		loNewDayActeOccurrencesByActe.set(poActeOccurrence.acte, laNewDayActeOccurrences);
		poTraitementActesOccurrencesByDay.set(pnNewDayIndex, loNewDayActeOccurrencesByActe);
	}

	/** Crée les différentes séances dans le traitement.
	 * @param paActeOccurrences Tableau de séances temporaires.
	 * @param poTraitement
	 */
	private createSeances(paActeOccurrences: Array<IActeOccurrence>, poTraitement: Traitement): Seance[] {
		const laCreatedSeances: Seance[] = []; // Tableau des séances crées.

		ArrayHelper.dynamicSortMultiple(paActeOccurrences, ["date", "iterationIndex", "intervenantIds"]); // Tri du tableau des séances générées.

		const loGroupedActeOccurrences: Map<string, IActeOccurrence[]> = ArrayHelper.groupBy(paActeOccurrences,
			(poActeOccurrence: IActeOccurrence) => (poActeOccurrence.intervenantIds?.join() ?? "") + poActeOccurrence.date.getTime()
		);

		// On effectue un tri pour faire passer les itérations d'actes avec une séance en premières (pour la génération de séances).
		loGroupedActeOccurrences.forEach((paGroupedActesIterations: IActeOccurrence[]) => {
			ArrayHelper.dynamicSort(paGroupedActesIterations, "canceled");

			paGroupedActesIterations.forEach((poActeOccurrence: IActeOccurrence, pnIndex: number) => {
				const loSeance: Seance = this.innerCreateSeances(poTraitement, laCreatedSeances, poActeOccurrence, paGroupedActesIterations[pnIndex - 1]);
				const loActe = new Acte(poActeOccurrence.acte);
				loActe.etat = EEtatActe.to_be_done
				loActe.canceled = poActeOccurrence.canceled;
				loSeance.place = poActeOccurrence.place;
				loSeance.actes.push(loActe);
			});
		});

		return laCreatedSeances;
	}

	private applyRangeRecurrence(paDayActeOccurrences: IActeOccurrence[]): boolean {
		let lbDateModified = false;

		const laActesIterationsThatMatch: IActeOccurrence[][] = [];
		paDayActeOccurrences.forEach((poGroupedActeOccurrence: IActeOccurrence) => {
			const laLocalActesIterationsThatMatch: IActeOccurrence[] = [poGroupedActeOccurrence];
			laActesIterationsThatMatch.push([poGroupedActeOccurrence]); // On ajoute au minimum l'acte seul car il match au moins avec lui même.

			paDayActeOccurrences.forEach((poActeOccurrence: IActeOccurrence) => {
				if (
					poGroupedActeOccurrence !== poActeOccurrence &&
					poGroupedActeOccurrence.guid !== poActeOccurrence.guid &&
					laLocalActesIterationsThatMatch.every((poActeOccurrenceThatMatch: IActeOccurrence) =>
						this.getMatchingDate([poActeOccurrenceThatMatch, poActeOccurrence])
					)
				) {
					laLocalActesIterationsThatMatch.push(poActeOccurrence);
					laActesIterationsThatMatch.push([...laLocalActesIterationsThatMatch]);
				}
			});
		});

		ArrayHelper.dynamicSort(laActesIterationsThatMatch, "length", ESortOrder.descending);

		let ldMatchingDate: Date;
		const laAlreadyParsedActeOccurrences: IActeOccurrence[] = [];
		for (let lnIndex = 0; lnIndex < laActesIterationsThatMatch.length; ++lnIndex) {
			const laMatchingActesOccurrence: IActeOccurrence[] = laActesIterationsThatMatch[lnIndex];

			if (!ArrayHelper.hasElements(ArrayHelper.intersection(laAlreadyParsedActeOccurrences, laMatchingActesOccurrence))) {
				ldMatchingDate = this.getMatchingDate(laMatchingActesOccurrence);
				if (ldMatchingDate) {
					laMatchingActesOccurrence.forEach((poMatchingActeOccurrence: IActeOccurrence) => {
						if (DateHelper.diffMinutes(poMatchingActeOccurrence.date, ldMatchingDate) !== 0) {
							poMatchingActeOccurrence.date = ldMatchingDate;
							lbDateModified = true;
						}
					});

					laAlreadyParsedActeOccurrences.push(...laMatchingActesOccurrence);
				}
			}
		}

		return lbDateModified;
	}

	private getMatchingDate(paMatchingActeOccurrences: IActeOccurrence[]): Date {
		let ldMinDate: Date;
		let ldMaxDate: Date;
		ArrayHelper.dynamicSort(paMatchingActeOccurrences, "isDateLocked", ESortOrder.descending);
		for (let lnIndex = 0; lnIndex < paMatchingActeOccurrences.length; ++lnIndex) {
			const loActeOccurrence: IActeOccurrence = paMatchingActeOccurrences[lnIndex];
			let ldActeMinDate: Date;
			let ldActeMaxDate: Date;

			if (!loActeOccurrence.isDateLocked) {
				const loRepetition: DayRepetition = loActeOccurrence.recurrence.dayRepetitions[loActeOccurrence.iterationIndex];

				if (loRepetition) {
					ldActeMinDate = new Date(loActeOccurrence.date);
					ldActeMaxDate = new Date(loActeOccurrence.date);
					if (loRepetition.type === C_RANGE_REPETITION_TYPE) { // TODO Remplacer par instanceof lorsque le bug du ModelResolver dans jest sera corrigé.
						const loRangeRepetition: RangeRepetition = loRepetition as RangeRepetition;
						if (loRangeRepetition.from)
							ldActeMinDate.setHours(loRangeRepetition.from?.hours, loRangeRepetition.from?.minutes);
						if (loRangeRepetition.to) {
							ldActeMaxDate.setHours(loRangeRepetition.to?.hours, loRangeRepetition.to?.minutes);
							if (DateHelper.compareTwoDates(ldActeMaxDate, ldActeMinDate) < 0) // Cas d'une plage d'horaire à cheval sur 2 jours
								ldActeMaxDate = DateHelper.addDays(ldActeMaxDate, 1);
							ldActeMaxDate = DateHelper.addMinutes(ldActeMaxDate, -1);
						}
					}
				}
			}
			else {
				ldActeMinDate = new Date(loActeOccurrence.date);
				ldActeMaxDate = new Date(loActeOccurrence.date);
			}

			if (!ldActeMinDate)
				ldActeMinDate = new Date(loActeOccurrence.date);

			if (!ldMinDate || DateHelper.compareTwoDates(ldActeMinDate, ldMinDate) > 0)
				ldMinDate = ldActeMinDate;
			if (ldActeMaxDate && (!ldMaxDate || DateHelper.compareTwoDates(ldActeMaxDate, ldMaxDate) < 0))
				ldMaxDate = ldActeMaxDate;

			// Si la date min est supérieure ou égale à la date max, on retourne `undefined`.
			if (ldMaxDate && DateHelper.compareTwoDates(ldMaxDate, ldMinDate) < 0)
				return undefined;
		}

		return ldMinDate;
	}

	/** Crée les différentes séances dans le traitement.
	 * @param poTraitement
	 * @param paCreatedSeances Tableau des séances créées.
	 * @param poCurrentActeOccurrence Acte actuel à partir duquel créer une nouvelle séance.
	 * @param poBeforeLastActeOccurrence Avant dernier acte avec lequel créer la nouvelle (fusion de séance si même créneau horaire par exemple).
	 */
	private innerCreateSeances(poTraitement: Traitement, paCreatedSeances: Seance[], poCurrentActeOccurrence: IActeOccurrence, poBeforeLastActeOccurrence?: IActeOccurrence): Seance {
		let loSeance: Seance = ArrayHelper.getLastElement(paCreatedSeances);

		// // Si dates ou itérations différentes -> création d'une nouvelle séance.
		const moment: DayRepetition = poCurrentActeOccurrence.moment;
		// const dateSeance = Seance.getStartDateFromMoment("", poCurrentActeOccurrence.date);
		if (!loSeance || !poBeforeLastActeOccurrence || !this.isSeanceMatchingActeOccurrence(loSeance, poCurrentActeOccurrence)) {
			loSeance = new Seance(
				[],
				paCreatedSeances.length,
				poCurrentActeOccurrence.date,
				moment
			);

			loSeance.traitementId = poTraitement._id;
			loSeance.traitementRev = poTraitement._rev;
			loSeance.scheduled = true;
			loSeance.status = EStatusSeance.to_be_done;
			loSeance.intervenantIds = poCurrentActeOccurrence.intervenantIds;
			loSeance.infirmierId = poCurrentActeOccurrence.intervenantIds.length === 0
				? ''  // Si le tableau est vide, on assigne ""
				: loSeance.intervenantIds.filter(item => item.startsWith(EPrefix.contact)).length === 1
					? ArrayHelper.getFirstElement(loSeance.intervenantIds.filter(item => item.startsWith(EPrefix.contact))) || ''
					: '';  // Si il y a plus d'une personne ou aucun contact, on assigne ""
			paCreatedSeances.push(loSeance);
		}

		return loSeance;
	}

	private isSeanceMatchingActeOccurrence(poSeance: Seance, poActeOccurrence: IActeOccurrence): boolean {
		return DateHelper.compareTwoDates(poSeance.startDate, poActeOccurrence.date) === 0 &&
			poSeance.actes.every((poActe: Acte) => poActe.guid !== poActeOccurrence.guid);
	}

	/** Calcul des dates pour les séances et génère toutes les séances pour un traitement, groupé par jour.
	 * @param poTraitement
	 */
	private generateActesOccurrences(poTraitement: Traitement, psSectorId?: string): Map<number, Map<Acte, IActeOccurrence[]>> {
		const loPerformanceManager = new PerformanceManager;
		loPerformanceManager.markStart();

		// On crée la liste des dates groupées par jour pour lesquels on va vouloir effectuer l'acte.
		const loOccurrencesByDay = new Map<number, Map<Acte, IActeOccurrence[]>>();

		poTraitement.actes.forEach((poActe: Acte) => {
			this.createActeOccurrences(
				poActe,
				poTraitement,
				(pnDayIndex: number, paActeOccurrences: IActeOccurrence[]) => {
					const loOccurrencesByActe: Map<Acte, IActeOccurrence[]> = loOccurrencesByDay.get(pnDayIndex) ?? new Map();

					loOccurrencesByActe.set(poActe, paActeOccurrences);

					loOccurrencesByDay.set(pnDayIndex, loOccurrencesByActe);
				},
				psSectorId
			);
		});

		console.debug(`${this.logSourceId}Génération des occurrences d'actes du traitement ${poTraitement._id} en ${loPerformanceManager.markEnd().measure()}ms.`);

		return loOccurrencesByDay;
	}

	private execActeConstraints(poActeOccurrence: IActeOccurrence): boolean {
		let lbHasExecutedConstraint = false;
		for (let lnIndex = 0; lnIndex < poActeOccurrence.acte.constraints.length; ++lnIndex) {
			const loConstraint: Constraint = poActeOccurrence.acte.constraints[lnIndex];

			if (!poActeOccurrence.executedConstraints.includes(loConstraint) && loConstraint.match(poActeOccurrence)) {
				const ldOldDate: Date = poActeOccurrence.date;
				const laOldIntervenants: string[] = [...(poActeOccurrence.intervenantIds ?? [])];
				loConstraint.action(poActeOccurrence);

				if (!poActeOccurrence.areIntervenantsLocked)
					poActeOccurrence.areIntervenantsLocked = !ArrayHelper.areArraysEqual(laOldIntervenants, poActeOccurrence.intervenantIds);

				if (!poActeOccurrence.isDateLocked)
					poActeOccurrence.isDateLocked = DateHelper.diffMinutes(ldOldDate, poActeOccurrence.date) !== 0;

				poActeOccurrence.executedConstraints.push(loConstraint);
				lbHasExecutedConstraint = true;
				lnIndex = 0;
			}
		}

		return lbHasExecutedConstraint;
	}

	/** Crée les dates de réalisation d'un acte en fonction de son paramètrage.
	 * @param poActe
	 * @returns Les dates groupées par jour.
	 */
	private createActeOccurrences(
		poActe: Acte,
		poTraitement: Traitement,
		pfOnDateFullyGenerated: (pnDayIndex: number, paActeOccurrences: IActeOccurrence[]) => void,
		psSectorId?: string
	): void {
		const laRecurrences: Recurrence[] = [...(poActe.recurrences ?? [])];
		if (poActe.acteModalEditBinding) {
			const loRecurrence: Recurrence = ArrayHelper.getFirstElement(poActe.recurrences) ?? new Recurrence;
			loRecurrence.durationValue = poActe.acteModalEditBinding.durationValue;
			loRecurrence.durationType = poActe.acteModalEditBinding.durationType;
			loRecurrence.repetitionType = poActe.acteModalEditBinding.repetitionType;
			loRecurrence.repetitionValue = poActe.acteModalEditBinding.repetitionValue;
			ArrayHelper.pushIfNotPresent(laRecurrences, loRecurrence);
		}
		const loDates = new Map<number, IActeOccurrence[]>();
		let lnPreviousDay: number;

		let recurrenceIndex = 0;
		let listRecurrencesDayRepetitions = [...poActe.recurrences[0].dayRepetitions];

		laRecurrences.forEach((poRecurrence: Recurrence) =>
			poRecurrence.generateDates(
				poActe.startDate ?? poTraitement.beginDate,
				poActe.weekRepetition?.value,
				(pdDate: Date, pnIndex: number, pbLocked?: boolean) => {
					if (pdDate && (poActe.startOffset ?? 0) <= pnIndex) {
						const lnDiffDays: number = DateHelper.diffDays(pdDate, poTraitement.beginDate);
						const lbNewDay: boolean = lnPreviousDay !== lnDiffDays;
						if (lbNewDay && lnPreviousDay !== undefined)
							recurrenceIndex = 0;

						const laGroupedDates: IActeOccurrence[] = lbNewDay ? [] : loDates.get(lnDiffDays);

						const currentDayRepetition: DayRepetition = listRecurrencesDayRepetitions[recurrenceIndex]

						laGroupedDates.push({
							date: pdDate,
							iterationIndex: laGroupedDates.length,
							acte: poActe,
							intervenantIds: [],
							guid: poActe.guid,
							place: poActe.place,
							canceled: poActe.canceled,
							recurrence: poRecurrence,
							executedConstraints: [],
							isDateLocked: pbLocked,
							moment: currentDayRepetition
						});
						if (listRecurrencesDayRepetitions.length != 1) {
							recurrenceIndex++;
						}


						if (lbNewDay) {
							pfOnDateFullyGenerated(lnDiffDays, laGroupedDates);
							loDates.set(lnDiffDays, laGroupedDates);
							lnPreviousDay = lnDiffDays;
						}
					}
				}
			)
		);

		this.applyEndOffset(poActe, loDates);
	}

	private applyEndOffset(poActe: Acte, loActeOccurrenceByDay: Map<number, IActeOccurrence[]>): void {
		if (poActe.endOffset > 0) {
			const laKeys: number[] = MapHelper.keysToArray(loActeOccurrenceByDay);
			let lnEndOffset: number = poActe.endOffset;

			for (let lnIndex = laKeys.length - 1; lnIndex > 0; lnIndex--) {
				const lnKey: number = laKeys[lnIndex];
				const laActeOccurrence: IActeOccurrence[] = loActeOccurrenceByDay.get(lnKey);

				if (lnEndOffset > laActeOccurrence.length)
					lnEndOffset = lnEndOffset - ArrayHelper.clear(laActeOccurrence).length;
				else {
					laActeOccurrence.splice(laActeOccurrence.length - lnEndOffset);
					break;
				}
			}
		}
	}

	/** Génère les séances pour le traitement en cours (et efface les précédentes).
	 * @param poTraitement
	 * @param poPatient Patient lié au traitement.
	 * @param pbShouldAutoCreateMajoration
	 * @param pbIsAutoRulesEnable
	 * @param psSectorId
	 * @param paPrestations
	 * @param paCotationRules
	 * @param paMajorations
	 * @param paIndemnites
	 */
	public generateSeances(
		poTraitement: Traitement,
		poPatient: IPatient,
		pbShouldAutoCreateMajoration: boolean = true,
		pbIsAutoRulesEnable: boolean = true,
		poAffectationsBySectorAndDays?: IDaySectorAffectationsMap,
		psSectorId?: string,
		paCotationRules?: ICotationRuleDocument[],
		paMajorations?: IActeDocumentByLc[],
		paIndemnites?: IDeplacementByProfession[],
		poRange?: IRange<Date>
	): Observable<Seance[]> {
		if (ObjectHelper.isNullOrEmpty(poPatient))
			return of([]);

		const loPerformanceManager = new PerformanceManager;

		return defer(() => {
			loPerformanceManager.markStart();
			return this.createTraitementActeOccurrences(poTraitement, poAffectationsBySectorAndDays, psSectorId, poRange);
		})
			.pipe(
				mergeMap((paActeOccurences: IActeOccurrence[]) => this.initSeances(
					poTraitement,
					poPatient,
					this.createSeances(paActeOccurences, poTraitement), // On crée les séances à partir des actes.
					pbShouldAutoCreateMajoration,
					pbIsAutoRulesEnable,
					paCotationRules,
					paMajorations,
					paIndemnites
				)),
			);
	}

	public enableMajoration(poSeance: Seance, poMajorationToEnable: Majoration): Seance {
		const laMajorations: Majoration[] = poSeance.majorations;

		let lbIsMajorationAlreadyAdded = false;

		// On désactive la majoration dim et jf si on n'est pas sur un jour le permettant.
		if (poMajorationToEnable.type === EMajorationType.SundayAndHolyday && !this.isSundayOrPublicHoliday(poSeance.startDate))
			poMajorationToEnable.disabled = true;

		// Si le tableau de majorations de cette séance contient déjà la majoration qu'on veut ajouter, pas besoin de l'ajouter mais on la réactive si elle ne l'est pas.
		laMajorations.forEach((poMajoration: Majoration) => {
			if (poMajoration.type === poMajorationToEnable.type) {
				lbIsMajorationAlreadyAdded = true;

				poMajoration.disabled = poMajorationToEnable.disabled;
			}
		});

		if (!lbIsMajorationAlreadyAdded)
			laMajorations.push(poMajorationToEnable);

		return poSeance;
	}

	/** Permet d'ajouter une indemnité ou de l'activer si elle était déjà présente mais désactivée.
	 * @param poTraitement
	 * @param poSeance
	 * @param psIndemniteType
	 * @param paDeplacementsByProfession
	 * @param pbForce
	 */
	public enableIndemnite(
		poTraitement: Traitement,
		poSeance: Seance,
		psIndemniteType: EIndemniteType,
		paDeplacementsByProfession: IDeplacementByProfession[],
		pbForce?: boolean
	): void {

		let lbIsIndemniteAlreadyAdded = false;
		poSeance.indemnites.forEach((poIndemnite: Indemnite) => {
			if (poIndemnite.type === psIndemniteType) {
				poIndemnite.disabled = false;
				poIndemnite.force = pbForce;
				lbIsIndemniteAlreadyAdded = true;
			}
		});

		if (!lbIsIndemniteAlreadyAdded) {
			const loIndemnite: Indemnite = this.isvcIndemnite.createNewIndemnite(
				this.isvcIndemnite.getIndemniteIdFromSecteurType(poTraitement.deplacement.sectorType),
				psIndemniteType,
				paDeplacementsByProfession,
				poTraitement.deplacement,
				poSeance.startDate
			);

			loIndemnite.force = pbForce;

			poSeance.indemnites.push(loIndemnite);
		}

		// On gère le cas IFI/IFD
		if (psIndemniteType === EIndemniteType.IFI)
			this.disableIndemnite(poSeance, EIndemniteType.IFD);
		else if (psIndemniteType === EIndemniteType.IFD)
			this.disableIndemnite(poSeance, EIndemniteType.IFI);
	}

	public disableMajoration(poSeance: Seance, poMajorationToDisable: Majoration | EMajorationType): Seance {
		const loMajorationToDisable: Majoration = typeof poMajorationToDisable === "string" ? poSeance.majorations.find((poMajoration: Majoration) => poMajoration.type === poMajorationToDisable) : poMajorationToDisable;

		if (loMajorationToDisable)
			loMajorationToDisable.disabled = true;

		return poSeance;
	}

	/** Supprime ou désactive une indemnité du tableau passé en paramètres.
	 * @param poSeance
	 * @param peIndemniteType Type d'indemnité à supprimer.
	 * @returns L'indemnité supprimée.
	 */
	public disableIndemnite(poSeance: Seance, peIndemniteType: EIndemniteType): Indemnite {
		const loIndemnites: Indemnite = findLast(poSeance.indemnites, (poIndemnite: Indemnite) => poIndemnite.type === peIndemniteType);

		if (loIndemnites)
			loIndemnites.disabled = true;

		return loIndemnites;
	}

	/** Supprime une indemnité de la séance.
	 * @param poSeance
	 * @param peIndemniteType Type d'indemnité à supprimer.
	 * @returns L'indemnité supprimée.
	 */
	public removeIndemnite(poSeance: Seance, peIndemniteType: EIndemniteType): Indemnite {
		return ArrayHelper.removeElementByFinder(poSeance.indemnites, (poItem: Indemnite) => poItem.type === peIndemniteType);
	}

	/** Supprime une majoration de la séance.
	 * @param poSeance
	 * @param peMajorationType Type de majoration à supprimer.
	 * @returns La majoration supprimée.
	 */
	public removeMajoration(poSeance: Seance, peMajorationType: EMajorationType): Majoration {
		return ArrayHelper.removeElementByFinder(poSeance.majorations, (poItem: Majoration) => poItem.type === peMajorationType);
	}

	/** Initialise les séances du traitement en paramètre. */
	private initSeances(poTraitement: Traitement,
		poPatient: IPatient,
		paNewSeances: Seance[],
		pbShouldAutoCreateMajoration: boolean,
		pbIsAutoRulesEnable: boolean,
		paCotationRules?: ICotationRuleDocument[],
		paMajorations?: IActeDocumentByLc[],
		paIndemnites?: IDeplacementByProfession[]
	): Observable<Seance[]> {
		const laSeances: Seance[] = this.getInitSeances(paNewSeances, poTraitement);
		return of(laSeances);
	}

	private canAddIFI(poSeancesByDay: Map<string, Seance[]>, poSeance: Seance) {
		return poSeancesByDay.get(DateHelper.transform(poSeance.startDate, ETimetablePattern.dd_MM_yyyy))
			?.filter((poDaySeance: Seance) => this.isvcIndemnite.isIndemniteEnabled(poDaySeance.indemnites, EIndemniteType.IFI))
			.length < IndemniteService.C_MAX_DAILY_IFI;
	}

	private getInitSeances(paSeances: Seance[], poTraitement: Traitement): Seance[] {
		const laSeances: Seance[] = [];

		paSeances.forEach((poSeance: Seance) => {
			if (poSeance) {
				poSeance.patientId = poTraitement.patientId;
				laSeances.push(poSeance);
			}
		});

		return this.mergeSeances(laSeances);
	}

	private mergeSeances(laSeances: Seance[]): Seance[] {
		return this.groupMergeableSeances(laSeances)
			.map((paSeances: Seance[]) => {
				return paSeances.reduce((poPreviousSeance: Seance, poCurrentSeance: Seance) => {
					if (!poPreviousSeance)
						return poCurrentSeance;

					if (ArrayHelper.hasElements(poCurrentSeance.majorations)) {
						poPreviousSeance.majorations = ArrayHelper.unique((poPreviousSeance.majorations ?? []).concat(poCurrentSeance.majorations),
							(poMajoration: Majoration) => poMajoration.id);
					}

					poPreviousSeance.actes.push(...(poCurrentSeance.actes ?? []));

					return poPreviousSeance;
				});
			});
	}

	private groupMergeableSeances(paSeances: Seance[]): Seance[][] {
		return ArrayHelper.flat(MapHelper.valuesToArray(
			ArrayHelper.groupBy(paSeances, (poSeance: Seance) => poSeance.startDate.getTime() + (poSeance.intervenantIds?.sort().join() ?? "") + poSeance.status)
		).map((paDaySeances: Seance[]) => {
			const loMap = new Map<Acte[], Seance[]>();

			paDaySeances.forEach((poSeance: Seance) => {
				if (loMap.size === 0)
					loMap.set([...(poSeance.actes ?? [])], [poSeance]);
				else {
					const laMatchingActes: Acte[] = MapHelper.keysToArray(loMap)
						.find((paActes: Acte[]) => !ArrayHelper.hasElements(ArrayHelper.intersection(paActes, poSeance.actes, (poActeA: Acte, poActeB: Acte) => poActeA.guid === poActeB.guid))
						) ?? [];

					laMatchingActes.push(...(poSeance.actes ?? []));

					const laSeances: Seance[] = loMap.get(laMatchingActes) ?? [];

					laSeances.push(poSeance);

					loMap.set(laMatchingActes, laSeances);
				}
			});

			return MapHelper.valuesToArray(loMap);
		}));
	}

	public generateSeanceEventIdStart(pdEvent?: Date): string {
		if (!pdEvent)
			return IdHelper.buildChildId(EPrefix.event, IdHelper.buildChildId(C_PREFIX_TRAITEMENT, IdHelper.buildVirtualNode([UserData.currentSite._id, C_PREFIX_PATIENT]), ""), "");

		return IdHelper.buildChildId(
			EPrefix.event,
			IdHelper.buildChildId(
				C_PREFIX_TRAITEMENT,
				IdHelper.buildVirtualNode([UserData.currentSite._id, DateHelper.toUTCString(pdEvent, EUTCAccuracy.minutes), C_PREFIX_PATIENT]
				),
				""
			),
			""
		);
	}
	// evt_trait_site~pat_default~201601050446~pcuoezI4iRv0q0nXSNmJT_uvUaNyTu7EtJxgF384FxJ_3dVyUa6oFbloHAJ1fPoEN
	public generateSeanceEventId(pdEvent: Date, poTraitement: Traitement): string {
		return IdHelper.buildChildId(
			EPrefix.event,
			IdHelper.buildChildId(
				C_PREFIX_TRAITEMENT,
				IdHelper.buildVirtualNode([poTraitement.siteId, DateHelper.toUTCString(pdEvent, EUTCAccuracy.minutes), poTraitement.patientId]
				),
				poTraitement.guid
			)
		);
	}

	/** Récupére la date de fin de la dernière séance.
	 * @param paSeances
	 */
	public getSeancesMaxDate(paSeances: ISeance[]): Date {
		if (!ArrayHelper.hasElements(paSeances))
			return null;
		else {
			return ArrayHelper.getFirstElement(
				paSeances.sort((poSeanceA: ISeance, poSeanceB: ISeance) => DateHelper.compareTwoDates(poSeanceB.endDate, poSeanceA.endDate))
			)
				.endDate;
		}
	}

	/** Récupére la date de début de la première séance.
	 * @param paSeances
	 */
	public getSeancesMinDate(paSeances: ISeance[]): Date {
		if (!ArrayHelper.hasElements(paSeances))
			return null;
		else {
			return ArrayHelper.getFirstElement(
				paSeances.sort((poSeanceA: ISeance, poSeanceB: ISeance) => DateHelper.compareTwoDates(poSeanceA.startDate, poSeanceB.startDate))
			)
				.startDate;
		}
	}

	public createAndSavePrestation(seance: Seance, traitement: Traitement): Observable<IdlPrestation> {
		let observationPresta: string;
		//On retire les actes annulés et non réalisés
		seance.actes = seance.actes.filter((poActe: Acte) => !poActe.canceled && poActe.etat !== EEtatActe.not_done);

		return this.svcObservation.getEntityObservation(traitement._id, seance.startDate)
			.pipe(
				tap((observation: Observation) => observationPresta = observation?.description),
				mergeMap(() => {
					const prestation: IdlPrestation = this.createSeancePrestation(traitement, seance, observationPresta);

					// Sauvegarde la prestation, puis retourne la prestation une fois sauvegardée
					return this.svcPrestation.savePrestation(prestation).pipe(
						mergeMap(() => {
							// Sauvegarde de la séance après avoir sauvegardé la prestation
							return this.svcSeance.updateSeance(seance, false).pipe(
								map(() => prestation) // Retourne la prestation
							);
						}));
				}),
			);
	}

	public createAndSavePrestationOptimise(
		seance: Seance,
		traitement: Traitement,
		prestationsToSave: IdlPrestation[],
		tarification: boolean = false
	): Observable<IdlPrestation> {
		// Retire les actes annulés et non réalisés
		seance.actes = seance.actes.filter((poActe: Acte) => !poActe.canceled && poActe.etat !== EEtatActe.not_done);
		seance.actes.forEach(acte => {
			if(acte.keyLetters === "AMI" && acte.isAmx){
				if(seance.isSeanceDependance){
					acte.keyLetters = "AMX";
				}else{
					acte.keyLetters = "AMI";
				}
			}
		});
		// Création de la prestation
		const prestation: IdlPrestation = this.createSeancePrestation(traitement, seance, "", tarification);

		// Ajout de la prestation à la liste pour sauvegarde groupée
		prestationsToSave.push(prestation);

		return of(prestation);
	}

	public static sortSeancesByDate<T extends ISeance>(paSeances: T[]): T[] {
		return SeancesHelper.sortSeancesByDate(paSeances);
	}

	public getConstraint<T extends Constraint>(
		poConstraintType: Type<T>,
		poResponse: IChooseSeancesToModifiyResponse,
		poStartSeance: Seance,
		pdEnd?: Date
	): T {
		const loConstraint: T = new poConstraintType;
		loConstraint.occurrenceComparators.push(
			...this.getActeOccurrenceComparatorsFrom(poResponse, poStartSeance.startDate, poStartSeance.intervenantIds, pdEnd)
		);
		return loConstraint;
	}

	public getActeOccurrenceComparatorsFrom(
		poResponse: IChooseSeancesToModifiyResponse,
		pdStart: Date,
		paIntervenants?: (IGroupMember | string)[],
		pdEnd?: Date
	): ActeOccurrenceComparator[] {
		const laOccurrenceComparators: ActeOccurrenceComparator[] = [];

		const lbHasSameTime: boolean = poResponse.filters.includes(EChoiceFilter.sameTime);
		const lbHasSameDay: boolean = poResponse.filters.includes(EChoiceFilter.sameDay);
		const lbHasSameIntervant: boolean = poResponse.filters.includes(EChoiceFilter.sameIntervenant);
		const lbHasFuture: boolean = poResponse.filters.includes(EChoiceFilter.future);

		if (lbHasSameIntervant && ArrayHelper.hasElements(paIntervenants)) {
			laOccurrenceComparators.push(new ActeOccurrenceIntervenantsComparator({
				intervenantIds: paIntervenants.map((poIntervenant: (IGroupMember | string)) =>
					typeof poIntervenant === "string" ? poIntervenant : poIntervenant._id)
			}));
		}
		if (lbHasSameTime || lbHasSameDay) {
			laOccurrenceComparators.push(new ActeOccurrenceDateTimeComparator({
				day: lbHasSameDay ? pdStart : undefined,
				hours: lbHasSameTime ? pdStart.getHours() : undefined,
				minutes: lbHasSameTime ? pdStart.getMinutes() : undefined
			}));
		}
		if (lbHasFuture || pdEnd)
			laOccurrenceComparators.push(new ActeOccurrenceRangeComparator({ from: pdStart, to: pdEnd }));

		if (!ArrayHelper.hasElements(laOccurrenceComparators)) {
			laOccurrenceComparators.push(new ActeOccurrenceDateTimeComparator({
				day: pdStart,
				hours: pdStart.getHours(),
				minutes: pdStart.getMinutes()
			}));
		}

		return laOccurrenceComparators;
	}

	private resetMajorations(paSeances: Seance[], poTraitement: Traitement, poPatient: IPatient, paMajorations?: IActeDocumentByLc[]): Observable<Seance[]>;
	private resetMajorations(poSeance: Seance, poTraitement: Traitement, poPatient: IPatient, paMajorations?: IActeDocumentByLc[]): Observable<Seance>;
	private resetMajorations(poData: Seance[] | Seance, poTraitement: Traitement, poPatient: IPatient, paMajorations?: IActeDocumentByLc[]): Observable<Seance[] | Seance> {
		const laSeances: Seance[] = coerceArray(poData);

		return defer(() => paMajorations ? of(paMajorations) : this.getMajorations())
			.pipe(
				tap((paResultMajorations: IActeDocumentByLc[]) => {
					this.majorationHolydays(laSeances, paResultMajorations);
					this.majorationMci(laSeances, paResultMajorations, poTraitement.pathologies);
					this.majorationMau(laSeances, paResultMajorations);
					this.applyNightMajorations(laSeances, paResultMajorations);
					this.applyMajorationMie(laSeances, poPatient, paResultMajorations);
					this.applyTraitementMajorations(laSeances, poTraitement, paResultMajorations);
					this.disableExcludeMajorations(laSeances);
				}),
				mapTo(poData)
			);
	}

	private applyTraitementMajorations(paSeances: Seance[], poTraitement: Traitement, paMajorations: IActeDocumentByLc[]): void {
		paSeances.forEach((poSeance: Seance) => {
			poTraitement.majorations?.forEach((poMajoration: ExtraCharge<EMajorationType>) => {
				if (poMajoration.match(poSeance.startDate)) {
					if (poMajoration.disabled)
						this.removeMajoration(poSeance, poMajoration.id);
					else {
						const loMajoration: Majoration = new Majoration(this.getMajorationIdFromType(poMajoration.id),
							poMajoration.id,
							this.getMajorationPriceFromArray(paMajorations, poMajoration.id),
							this.getMajorationDescriptionFromArray(paMajorations, poMajoration.id)
						);

						this.enableMajoration(poSeance, loMajoration);
					}
				}
			});
		});
	}

	private disableExcludeMajorations(paSeances: Seance[]): void {
		paSeances.forEach((poSeance: Seance) => {
			const laExcludeMajoration: EMajorationType[] = [];
			poSeance.actes.forEach((poActe: Acte) => {
				if (ArrayHelper.hasElements(poActe.excludeMajorations))
					laExcludeMajoration.push(...poActe.excludeMajorations as EMajorationType[]);
			});
			ArrayHelper.unique(laExcludeMajoration).forEach((peMajorationType: EMajorationType) => this.disableMajoration(poSeance, peMajorationType));
		});
	};

	/** Applique les majorations de nuit.
	 * @param paSeances Liste des séances sur lesquelles appliquer les majorations.
	 * @param paMajorations
	 */
	private applyNightMajorations(paSeances: Seance[], paMajorations: IActeDocumentByLc[]): void {
		paSeances.forEach((poSeance: Seance) => {
			if (poSeance.isProtected)
				return;

			const ldStartDate = new Date(poSeance.startDate);
			const lnHours: number = ldStartDate.getHours();

			// 20h-23h & 5h-8h
			if (!this.isProtectedMajorationType(EMajorationType.NightFirstHalf, poSeance.majorations)) {
				const loMajoration = new Majoration(this.getMajorationIdFromType(EMajorationType.NightFirstHalf),
					EMajorationType.NightFirstHalf,
					this.getMajorationPriceFromArray(paMajorations, EMajorationType.NightFirstHalf),
					this.getMajorationDescriptionFromArray(paMajorations, EMajorationType.NightFirstHalf));

				if (((lnHours >= 5 && lnHours < 8) || (lnHours >= 20 && lnHours < 23)))
					this.enableMajoration(poSeance, loMajoration);
				else
					this.disableMajoration(poSeance, loMajoration);
			}
			// 23h-5h
			if (!this.isProtectedMajorationType(EMajorationType.NightSecondHalf, poSeance.majorations)) {
				const loMajoration = new Majoration(this.getMajorationIdFromType(EMajorationType.NightSecondHalf),
					EMajorationType.NightSecondHalf,
					this.getMajorationPriceFromArray(paMajorations, EMajorationType.NightSecondHalf),
					this.getMajorationDescriptionFromArray(paMajorations, EMajorationType.NightSecondHalf));

				if ((lnHours >= 23 || lnHours < 5))
					this.enableMajoration(poSeance, loMajoration);
				else
					this.disableMajoration(poSeance, loMajoration);
			}

			// Si on a une majoration de nuit on doit la privilégier face à la majoration dim/jf
			if (poSeance.majorations.some((poMajoration: Majoration) =>
				!poMajoration.disabled && (poMajoration.type === EMajorationType.NightFirstHalf || poMajoration.type === EMajorationType.NightSecondHalf))
			)
				this.disableMajoration(poSeance, EMajorationType.SundayAndHolyday);
		});
	}

	/** Applique l'abattement sur les actes des séances.
	 * @param paSeances
	 * @param poPatient
	 * @returns
	 */
	public applyTaxAllowance(paSeances: Seance[], poPatient: IPatient): Observable<Seance[]> {
		const actesIds: string[] = ArrayHelper.unique(ArrayHelper.flat(ArrayHelper.flat(paSeances.map((poSeance: Seance) =>
			poSeance.actes.map((poActe: Acte) => poActe._id ?? [])))));

		SeanceService.sortSeancesByDate(paSeances);
		return defer(() => this.isvcActes.getActes(actesIds))
			.pipe(
				switchMap((actes: Acte[]) => {
					// On récupère les actes dans le référentiel pour mettre à jour les actes dans la seance
					let cotationRulesIds: string[] = [];
					actes.forEach((acte: Acte) => {
						cotationRulesIds.push(...(acte.cotationRulesIds ?? []));
						paSeances.forEach((seance: StoredSeance) => {
							seance.actes.forEach((seanceActe: Acte) => {
								if (seanceActe.id === acte.id) {
									seanceActe.cotationRulesIds = ArrayHelper.unique(acte.cotationRulesIds ?? []);
									seanceActe.isPackage = acte.isPackage;
									seanceActe.excludeMajorations = acte.excludeMajorations;
									seanceActe.excludeFromTaxAllowance = acte.excludeFromTaxAllowance;
								}
							});
						});
					})
					return this.isvcActes.getCotationRules(ArrayHelper.unique(cotationRulesIds));
				}),
				map((paCotationRulesResult: ICotationRuleDocument[]) => {
					const loCotationRulesByIds: Map<string, ICotationRuleDocument[]> = ArrayHelper.groupBy(paCotationRulesResult, (poCotationRule: ICotationRuleDocument) => poCotationRule._id);
					const laCheckedSeances: Seance[] = [];

					paSeances.forEach((poSeance: Seance) => {
						this.resetTaxAllowance(poSeance);
						this.inner_applyTaxAllowance_initialApply(poSeance, poPatient, loCotationRulesByIds, laCheckedSeances);

						// Gestion des soins postopératoires
    					this.handleSoinsPostOperatoires(poSeance);

						// On groupe et trie les actes par packageId (forfaits d'abord, puis par prix décroissant)
						let laActesByPackageId: Acte[][] = this.getSortedActesByPackageId(poSeance.actes);

						const pdsInTopTwo: boolean = this.isPdsInTopTwo(laActesByPackageId);

						let lnCpt = 0;
						let lbHasPackage = false;
						// De base on a le droit de facturer 2 actes.
						let lnActeToPrestation = 2;									

						// On applique les abattements par groupe.
						laActesByPackageId.forEach((paActes: Acte[]) => {
							let lbIncrementCpt = false;

							paActes.forEach((poActe: Acte) => {
								
								// Si l'acte PDS est dans 2 plus gros coefficient, alors les 2 premiers actes sont à 100%
								if (pdsInTopTwo && !poActe.excludeFromTaxAllowance && lnCpt <= 1) {
									lbIncrementCpt = true;
									poActe.taxAllowanceExplication = poActe._id === ACT_IDS.AMIX_1p5_PRISE_DE_SANG ? TAX_ALLOWANCE_MESSAGES.T_PDS : TAX_ALLOWANCE_MESSAGES.T_ASSOC_PDS ;
								} else if (poActe.taxAllowance > 0) { // Si le taux est de 0, c'est que l'acte a été exclu du calcul.
									if (poActe.isPackage)
										lbHasPackage = true;

									// On ne compte pas le forfait dans le nombre d'acte pour calculer l'abattement ni les actes exclus du calcul d'abattement.
									this.inner_applyTaxAllowance_apply(lbHasPackage, poActe, poSeance, poPatient, lnCpt, loCotationRulesByIds, laCheckedSeances);

									if (!poActe.isPackage && !poActe.excludeFromTaxAllowance)
										lbIncrementCpt = true;
									else // Si c'est un forfait ou un acte à exclure du calcul de l'abattement, on prestation.
										lnActeToPrestation++;
								}
							});

							// On incrémente une fois par groupe.
							if (lbIncrementCpt)
								lnCpt++;
						});

						// On trie par prix total.
						laActesByPackageId.sort((paActesA: Acte[], paActesB: Acte[]) => {
							const allExcludedA = paActesA.every(acte => acte.excludeFromTaxAllowance);
							const allExcludedB = paActesB.every(acte => acte.excludeFromTaxAllowance);

							const diffExclude = Number(allExcludedB) - Number(allExcludedA);

							if (diffExclude !== 0) {
								return diffExclude;
							}

							// on trie par prix total décroissant
							return ActesService.getTotalPrice(paActesB) - ActesService.getTotalPrice(paActesA);
						});

						
						// On élimine les moins cher pour facturer de manière optimisée.
						laActesByPackageId.slice(lnActeToPrestation).forEach((paActes: Acte[]) => paActes.forEach((poActe: Acte) => poActe.taxAllowance = 0));
						// On itère d'abord sur chaque groupe (sous-tableau)
						laActesByPackageId.forEach((packageActes) => {
							if (packageActes.length > 1) {
								packageActes.forEach((acte) => {
									this.setTaxAllowanceExplicationByPackageId(acte);
								});
							} 
						});
						laCheckedSeances.push(poSeance);
					});

					return paSeances;
				})
			);
	}

	private handleSoinsPostOperatoires(poSeance: Seance): void {
		// On récupère les actes qui ont le packageId = "soinsPostop"
		let soinsPostop: Acte[] = poSeance.actes.filter((poActe: Acte) => poActe.packageId === PACKAGE_IDS.SOINS_POSTOPERATOIRES);

		const has4p2 = soinsPostop.some(a => a._id === ACT_IDS.AMI_4p2_SEANCE_SURVEILLANCE_ANALGESIE_POSTOP);
		const has3p9 = soinsPostop.some(a => a._id === ACT_IDS.AMI_3p9_SEANCE_SURVEILLANCE_DOMICILE_POSTOP);

		if (has4p2 && has3p9) {
			soinsPostop = soinsPostop.filter(a => {
				if (a._id === ACT_IDS.AMI_3p9_SEANCE_SURVEILLANCE_DOMICILE_POSTOP) {
					a.packageId = undefined;
					return false;
				}
				return true;
			});
		} else if (!has4p2 && !has3p9) {
			soinsPostop.forEach(a => a.packageId = undefined);
			soinsPostop = [];
		}
		// On vérifie si on a des soins postopératoire dans la séance
		if (soinsPostop.length > 0) {
			//On trie les actes par coefficient décroissant
			soinsPostop.sort((a: Acte, b: Acte) => b.priceCoefficient - a.priceCoefficient);
			// On ne peut pas avoir plus de 2 actes postopératoire dans une même séance, on garde ceux avec le plus gros coefficient
			// On retire le packageId des autres actes pour les exclure du calcul
			for (let i = 2; i < soinsPostop.length; i++) {
				soinsPostop[i].packageId = undefined;
			}
		}
	}

		/**
	 * Regroupe et trie les actes par packageId (forfaits d'abord, puis par prix décroissant)
	 */
	private getSortedActesByPackageId(actes: Acte[]): Acte[][] {
		const grouped = MapHelper.valuesToArray(ArrayHelper.groupBy(actes, (a) => a.packageId ?? GuidHelper.newGuid()));
		this.inner_applyTaxAllowance_initialSort(grouped);
		return grouped;
	}

	private setTaxAllowanceExplicationByPackageId(acte: Acte): void {
		switch(acte.packageId){
			case PACKAGE_IDS.PANSEMENT_ULCERE_ESCARRE:
				if(acte._id === ACT_IDS.AMIX_1p1_ANALGESIE_TOPIQUE){
					acte.taxAllowanceExplication = TAX_ALLOWANCE_MESSAGES.T_ASSOC_PANSEMENT(acte.taxAllowance);
				}else{
					acte.taxAllowanceExplication = TAX_ALLOWANCE_MESSAGES.T_ASSOC_ANALGESIE(acte.taxAllowance);
				}
				break;
			case PACKAGE_IDS.DIABETIQUE:
				acte.taxAllowanceExplication = TAX_ALLOWANCE_MESSAGES.T_ASSOC_DIABETIQUE(acte.taxAllowance);
				break;
			case PACKAGE_IDS.PERFUSION:
			case PACKAGE_IDS.PERFUSION_CANCEREUX:
				if(acte._id === ACT_IDS.AMIX_9_PERF_COURTE || acte._id === ACT_IDS.AMIX_10_PERF_COURTE){
					acte.taxAllowanceExplication = TAX_ALLOWANCE_MESSAGES.T_ASSOC_PERF_LONGUE_OU_SUPP(acte.taxAllowance);
				}else{
					acte.taxAllowanceExplication = TAX_ALLOWANCE_MESSAGES.T_ASSOC_PERF_COURTE(acte.taxAllowance);
				}
				break;
			case PACKAGE_IDS.SOINS_POSTOPERATOIRES:
				if(acte._id === ACT_IDS.AMI_2p8_SURVEILLANCE_DRAIN_POSTOP || acte._id === ACT_IDS.AMI_2_RETRAIT_SONDE_URINAIRE_POSTOP){
					acte.taxAllowanceExplication = TAX_ALLOWANCE_MESSAGES.T_ASSOC_POSTOP_AMI(acte.taxAllowance);
				}else{
					acte.taxAllowanceExplication = TAX_ALLOWANCE_MESSAGES.T_ASSOC_POSTOP_SURVEILLANCE(acte.taxAllowance);
				}
				break;
			default: break;
		}
	}

	private resetTaxAllowance(poSeance: Seance): void {
		// On remet les abattement à leur valeur initiale.
		poSeance.actes.forEach((poActe: Acte) => poActe.taxAllowance = 1);
		// On trie pour avoir les packages en premier puis les actes par prix.
		poSeance.actes.sort((poActeA: Acte, poActeB: Acte) => {
			if (poActeA.isPackage && !poActeB.isPackage)
				return -1;
			else if (poActeB.isPackage && !poActeA.isPackage)
				return 1;
			return poActeB.price - poActeA.price;
		});
	}

	private inner_applyTaxAllowance_initialApply(
		poSeance: Seance,
		poPatient: IPatient,
		poCotationRulesByIds: Map<string, ICotationRuleDocument[]>,
		paCheckedSeances: Seance[]
	): void {
		poSeance.actes.forEach((poActe: Acte) => {
			// On nettoie les anciennes informations de groupement pour le calcul de l'abattement.
			poActe.packageId = undefined;
			// On applique les règles de cotation une première fois pour avoir les packageIds.
			this.applyCotationRules(poActe, poSeance, poPatient, poCotationRulesByIds, paCheckedSeances);
		});
	}

	private inner_applyTaxAllowance_initialSort(laActesByPackageId: Acte[][]): void {
		laActesByPackageId.sort((paActesA: Acte[], paActesB: Acte[]) => {
			const hasPackageA = paActesA.some((poActe: Acte) => poActe.isPackage);
			const hasPackageB = paActesB.some((poActe: Acte) => poActe.isPackage);

			if (hasPackageA && !hasPackageB) return -1;
			if (hasPackageB && !hasPackageA) return 1;

			const priceA = ActesService.getTotalPrice(paActesA);
			const priceB = ActesService.getTotalPrice(paActesB);

			const isPdsA = paActesA.some(a => a._id === ACT_IDS.AMIX_1p5_PRISE_DE_SANG);
			const isPdsB = paActesB.some(a => a._id === ACT_IDS.AMIX_1p5_PRISE_DE_SANG);

			if (isPdsA && !isPdsB) {
				if ((priceB / 2) < priceA) return -1;
			} 
			else if (isPdsB && !isPdsA) {
				if ((priceA / 2) < priceB) return 1;
			}

			return priceB - priceA;
		});
	}

	private isPdsInTopTwo(laActesByPackageId: Acte[][]): boolean {
		if (!laActesByPackageId || laActesByPackageId.length === 0) return false;
		//On retire les actes qui sont exclus de la tax allowance
		const packageIdsWithActesIncludedInTaxAllowance: Acte[][] = laActesByPackageId.filter(x => x.some(y => !y.excludeFromTaxAllowance));
		if (packageIdsWithActesIncludedInTaxAllowance.length === 0) return false;
		const topTwoPackages: Acte[][] = packageIdsWithActesIncludedInTaxAllowance.slice(0, 2);

		return topTwoPackages.some(packageActes => 
			packageActes.some(acte => acte._id === ACT_IDS.AMIX_1p5_PRISE_DE_SANG)
		);
	}

	private inner_applyTaxAllowance_apply(
		lbHasPackage: boolean,
		poActe: Acte,
		loSeance: Seance,
		poPatient: IPatient,
		lnCpt: number,
		poCotationRulesByIds: Map<string, ICotationRuleDocument[]>,
		paCheckedSeances: Seance[]
	): void {
		if ((lbHasPackage && !poActe.forceRullInPackage) || !this.applyCotationRules(poActe, loSeance, poPatient, poCotationRulesByIds, paCheckedSeances)) { // Si forfait ou si pas de règle de cotation appliquée.
			if (poActe.excludeFromTaxAllowance || lnCpt === 0)
				poActe.taxAllowance = 1; // Le premier acte hors forfait est à 100%.
			else if (lnCpt > 0)
				poActe.taxAllowance = 0.5;
		}
	}

	private isCotationRuleConditionValid(
		poCotationRule: ICotationRule,
		poActe: Acte,
		poSeanceToCheck: Seance,
		poPatient: IPatient,
		paCheckedSeances: Seance[]
	): boolean {
		// Si on a atteint le nombre d'acte limite pour cette règle on stoppe ici.
		if (!StringHelper.isBlank(poCotationRule.packageId) && ArrayHelper.hasElements(poCotationRule.limits) &&
			this.isCotationRuleLimitReached(poCotationRule, poActe, poSeanceToCheck))
			return false;
		else if (StringHelper.isBlank(poCotationRule.condition))
			return true;
		else if (poCotationRule.condition?.startsWith(ECotationConditionPattern.patientPathologiesContains)) {
			return !ArrayHelper.hasElements(ArrayHelper.getDifferences(
				this.extractValueFromCondition(poCotationRule.condition), coerceArray(poPatient?.pathologies ?? [])
			));
		}
		else if (poCotationRule.condition?.startsWith(ECotationConditionPattern.seanceActesContains)) {
			return !ArrayHelper.hasElements(ArrayHelper.getDifferences(
				this.extractValueFromCondition(poCotationRule.condition), poSeanceToCheck.actes.map((poSeanceActe: Acte) => poSeanceActe._id)
			));
		}
		else if (poCotationRule.condition?.startsWith(ECotationConditionPattern.seanceActesSome)) {
			return ArrayHelper.hasElements(ArrayHelper.intersection(
				this.extractValueFromCondition(poCotationRule.condition), poSeanceToCheck.actes.map((poSeanceActe: Acte) => poSeanceActe._id)
			));
		}
		else if (poCotationRule.condition?.startsWith(ECotationConditionPattern.daySeancesActesExceeds)) {
			const laValues: string[] = this.extractValueFromCondition(poCotationRule.condition);
			const lnCount: number = +laValues[1];

			if (!NumberHelper.isValidStrictPositive(lnCount) || poActe._id !== laValues[0])
				return false;

			return paCheckedSeances.filter((poSeance: Seance) =>
				DateHelper.diffDays(poSeance.startDate, poSeanceToCheck.startDate) === 0 && ActesService.hasActe(poSeance.actes, poActe._id)
			).length >= lnCount;
		}
		return false;
	}

	public isCotationRuleLimitReached(cotationRule: ICotationRule, acte: Acte, seance: Seance): boolean {
		const limit = cotationRule.limits?.find((limit: ICotationRuleLimit) => limit.id === '' || limit.id === acte._id);
		if (!limit) return false;

		const countOfActsByThisRule = seance.actes.filter((acte: Acte) => {
			if (acte.packageId !== cotationRule.packageId) return false;

			if(limit.id === '') {
				return acte.cotationRulesIds.includes((cotationRule as unknown as IStoreDocument)._id)
			} else {
				return acte._id === limit.id
			}
		}).length;

		return countOfActsByThisRule >= limit.value;
	}

	private extractValueFromCondition(psCondition: string): string[] {
		return ArrayHelper.getLastElement(/\((.*)\)/.exec(psCondition))?.replace(/\s/g, "").split(",");
	}

	private applyCotationRules(
		poActe: Acte,
		poSeance: Seance,
		poPatient: IPatient,
		poCotationRulesByIds: Map<string, ICotationRuleDocument[]>,
		paCheckedSeances: Seance[]
	): boolean {
		let lbCotationRuleApplied = false;
		let lbPackageIdApplied = false;

		poActe.cotationRulesIds?.forEach((psId: string) => {
			const loCotationRule: ICotationRule = ArrayHelper.getFirstElement(poCotationRulesByIds.get(psId));
			const test = loCotationRule && this.isCotationRuleConditionValid(loCotationRule, poActe, poSeance, poPatient, paCheckedSeances)
			if (test) {
				lbCotationRuleApplied = true;
				switch (loCotationRule.action) {
					case ECotationAction.cotation100:
						poActe.taxAllowance = 1;
						break;
					case ECotationAction.cotation50:
						poActe.taxAllowance = 0.5;
						break;
					case ECotationAction.cotation0:
						poActe.taxAllowance = 0;
						break;
					case ECotationAction.excludeFromTaxAllowance:
						poActe.taxAllowance = 1;
						poActe.excludeFromTaxAllowance = true;
						// Explication spécifique pour l'IFI 0.01
						poActe.taxAllowanceExplication = poActe._id !== ACT_IDS.IFI_0p01
							? TAX_ALLOWANCE_MESSAGES.T100_EXCLU
							: TAX_ALLOWANCE_MESSAGES.T001_IFI;
						break;
					default:
						lbCotationRuleApplied = false;
						break;
				}
				if (!StringHelper.isBlank(loCotationRule.packageId)) {
					poActe.packageId = loCotationRule.packageId;
					lbPackageIdApplied = true;
				}
				if (loCotationRule.forceInPackage)
					poActe.forceRullInPackage = loCotationRule.forceInPackage;
			}
			else if (!lbPackageIdApplied)
				poActe.packageId = undefined;
		});

		return lbCotationRuleApplied;
	}

	/** Ajout des majorations automatiques en fonction du jour (dim. et jours fériés) et aussi des actes uniques.
	 * @param paSeances
	 * @param paMajorations
	*/
	private majorationHolydays(paSeances: Seance[], paMajorations: IActeDocumentByLc[]): void {
		for (let lnIndex = 0, lnLength = paSeances.length; lnIndex < lnLength; ++lnIndex) {
			const loSeance: Seance = paSeances[lnIndex];
			const loMajoration: Majoration = new Majoration(`MAJ-${this.isvcApplication.profession}-${EMajorationType.SundayAndHolyday}`,
				EMajorationType.SundayAndHolyday,
				this.getMajorationPriceFromArray(paMajorations, EMajorationType.SundayAndHolyday),
				this.getMajorationDescriptionFromArray(paMajorations, EMajorationType.SundayAndHolyday)
			);

			if (loSeance.isProtected || this.isProtectedMajorationType(loMajoration.type, loSeance.majorations))
				continue;

			const ldStart: Date = new Date(loSeance.startDate);

			if (this.isSundayOrPublicHoliday(ldStart))
				this.enableMajoration(loSeance, loMajoration);
			else
				this.removeMajoration(loSeance, loMajoration.type);
		}
	}

	public isSundayOrPublicHoliday(pdDate: Date): boolean {
		// dimanche = 0.
		return pdDate.getDay() === 0 || DateHelper.isPublicHoliday(pdDate);
	}

	/** Ajout des majorations d'actes uniques.
	 * @param paSeances
	 * @param paMajorations
	*/
	private majorationMau(paSeances: Seance[], paMajorations: IActeDocumentByLc[]): void {
		for (let lnIndex = paSeances.length - 1; lnIndex >= 0; --lnIndex) {
			const loSeance: Seance = paSeances[lnIndex];
			const loMajoration: Majoration = new Majoration(
				"MAU",
				EMajorationType.Mau,
				this.getMajorationPriceFromArray(paMajorations, EMajorationType.Mau),
				this.getMajorationDescriptionFromArray(paMajorations, EMajorationType.Mau)
			);

			if (loSeance.isProtected || this.isProtectedMajorationType(loMajoration.type, loSeance.majorations))
				continue;

			if (loSeance.actes.filter((poActe: Acte) => !poActe.canceled).length === 1 && // il faut qu'il n'y ait qu'un seul acte dans la séance.
				loSeance.actes.some((poActe: Acte) => poActe.keyLetters === "AMI" && poActe.priceCoefficient < 2 && !poActe.isMciEligible)) // AMI && coef < 2 et pas de maj MCI = on applique la majo MAU
				this.enableMajoration(loSeance, loMajoration);
			else
				this.removeMajoration(loSeance, loMajoration.type);
		}
	}

	/** Ajout des majorations si acte éligible MCI.
	 * @param paSeances
	 * @param paMajorations
	*/
	private majorationMci(paSeances: Seance[], paMajorations: IActeDocumentByLc[], paPathologies?: EPathologie[]): void {
		for (let lnIndex = paSeances.length - 1; lnIndex >= 0; --lnIndex) {
			const loSeance: Seance = paSeances[lnIndex];
			const loMajoration: Majoration = new Majoration(
				"MCI",
				EMajorationType.Mci,
				this.getMajorationPriceFromArray(paMajorations, EMajorationType.Mci),
				this.getMajorationDescriptionFromArray(paMajorations, EMajorationType.Mci)
			);

			if (loSeance.isProtected || this.isProtectedMajorationType(loMajoration.type, loSeance.majorations))
				continue;

			if (loSeance.actes.some((poActe: Acte) => poActe.isMciEligible) || paPathologies?.includes(EPathologie.palliatif))
				this.enableMajoration(loSeance, loMajoration);
			else
				this.removeMajoration(loSeance, loMajoration.type);
		}
	}

	/** Ajout majoration si patient de moins de 7 ans.
	 * @param paSeances Liste des séances sur lesquelles appliquer les majorations.
	 * @param poPatient
	 * @param paMajorations
	*/
	private applyMajorationMie(paSeances: Seance[], poPatient: IPatient, paMajorations: IActeDocumentByLc[]): Seance[] {
		for (let lnIndex = paSeances.length - 1; lnIndex >= 0; --lnIndex) {
			const loSeance: Seance = paSeances[lnIndex];
			const loMajoration: Majoration = new Majoration(
				"MIE",
				EMajorationType.Mie,
				this.getMajorationPriceFromArray(paMajorations, EMajorationType.Mie),
				this.getMajorationDescriptionFromArray(paMajorations, EMajorationType.Mie)
			);

			if (loSeance.isProtected || this.isProtectedMajorationType(loMajoration.type, loSeance.majorations))
				continue;


			if (DateHelper.isDate(poPatient?.birthDate) && DateHelper.diffYear(new Date(loSeance.startDate), new Date(poPatient.birthDate)) < 7)
				this.enableMajoration(loSeance, loMajoration);
			else
				this.removeMajoration(loSeance, loMajoration.type);
		};
		return paSeances;
	}

	/** Vérifie si un certain type de majoration est présent dans un tableau de majorations et si il est protégé.
	 * @param poMajorationType Type de la majoration à vérifier.
	 * @param paMajorations Tableau des majorations à vérifier.
	 * @returns `true` si présent et protégé, `false` sinon.
	 */
	private isProtectedMajorationType(poMajorationType: EMajorationType, paMajorations: Array<Majoration>): boolean {
		return paMajorations?.some((poMajoration: Majoration) => poMajoration.type === poMajorationType && poMajoration.isProtected) ?? false;
	}

	/**
	 * Récupère l'id d'une majoration en fonction de son type
	 * @param poType Type de majoration
	 */
	public getMajorationIdFromType(poType: EMajorationType): string {
		switch (poType) {
			case EMajorationType.Mau:
				return `MAU`;
			case EMajorationType.Mci:
				return `MCI`;
			case EMajorationType.Mie:
				return `MIE`;
			case EMajorationType.SundayAndHolyday:
				return `MAJ-${this.isvcApplication.profession}-Dim`;
			case EMajorationType.NightFirstHalf:
				return `MAJ-${this.isvcApplication.profession}-N1`;
			case EMajorationType.NightSecondHalf:
				return `MAJ-${this.isvcApplication.profession}-N2`;
		}
		return '';
	}

	public getMajorationTypeFromId(id: string): EMajorationType | null {
		switch (id) {
			case 'MAU':
				return EMajorationType.Mau;
			case 'MCI':
				return EMajorationType.Mci;
			case 'MIP':
				return EMajorationType.Mip;
			case 'MIE':
				return EMajorationType.Mie;
			case `MAJ-${this.isvcApplication.profession}-Dim`:
				return EMajorationType.SundayAndHolyday;
			case `MAJ-${this.isvcApplication.profession}-N1`:
				return EMajorationType.NightFirstHalf;
			case `MAJ-${this.isvcApplication.profession}-N2`:
				return EMajorationType.NightSecondHalf;
			default:
				return null;
		}
	}


	/** Récupération de la description d'une majoration.
	 * @param paResults tableau des résultats des majorations du métier concerné.
	 * @param peMajorationType
	 */
	public getMajorationDescriptionFromArray(paResults: IActeDocumentByLc[], peMajorationType: EMajorationType): string {
		return this.getMajorationFromArray(paResults, peMajorationType)?.description;
	}

	/** Récupération du prix d'une majoration.
	 * @param paResults tableau des résultats des majorations du métier concerné.
	 * @param peMajorationType
	 */
	public getMajorationPriceFromArray(paResults: IActeDocumentByLc[], peMajorationType: EMajorationType): number {
		let lc_majo: IActeDocumentByLc = this.getMajorationFromArray(paResults, peMajorationType);
		if (lc_majo) {
			if (ArrayHelper.hasElements(lc_majo.tarif)) {
				return lc_majo.tarif[ConfigData.geoZoneApp - 1];
			} else if (ArrayHelper.hasElements(lc_majo.tarifs)) {
				const tarifIndemnite: ITarifLettreCle = lc_majo.tarifs.find((tar: ITarifLettreCle) => {
					return TarifHelper.getFiltreTarifLettreCleParDate(tar, new Date());
				});
				return tarifIndemnite ? tarifIndemnite.montant : 0;
			}
		}
		return 0;
	}

	/** Récupère une majoration depuis un tableau en fonction de son type.
	 * @param paResults
	 * @param peMajorationType
	 * @returns Majoration correspondant au type ou `undefined`.
	 */
	private getMajorationFromArray(paResults: IActeDocumentByLc[], peMajorationType: EMajorationType): IActeDocumentByLc {
		return paResults.find((poResult: IActeDocumentByLc) => poResult.id.indexOf(peMajorationType) !== -1);
	}

	/** Initialise le prix des différentes majorations. */
	public getMajorations(): Observable<IActeDocumentByLc[]> {
		const loParams: IDataSource = {
			databasesIds: this.isvcStore.getDatabasesIdsByRole(EDatabaseRole.formsEntries),
			viewName: "majoration/by_profession",
			viewParams: { key: this.isvcApplication.profession }
		};

		return this.isvcStore.get<IActeDocumentByLc>(loParams) // Récupère la liste des majorations du métier concerné.
			.pipe(
				catchError(poError => {
					console.error(`${this.logSourceId}Erreur récupération données sur la base ${JSON.stringify(loParams.databasesIds)} : `, poError);
					return throwError(poError);
				})
			);
	}


	public getDeplacements(): Observable<IActeDocumentByLc[]> {
		const loParams: IDataSource = {
			databasesIds: this.isvcStore.getDatabasesIdsByRole(EDatabaseRole.formsEntries),
			viewName: "deplacement/by_profession",
			viewParams: { key: this.isvcApplication.profession }
		};

		return this.isvcStore.get<IActeDocumentByLc>(loParams)
			.pipe(
				catchError(poError => {
					console.error(`${this.logSourceId}Erreur récupération données sur la base ${JSON.stringify(loParams.databasesIds)} : `, poError);
					return throwError(poError);
				})
			);
	}

	public getIntervenantConstraint(
		poResponse: IChooseSeancesToModifiyResponse,
		poStartSeance: Seance,
		paNewIntervenants: (IGroupMember | string)[],
		pdEnd?: Date
	): IntervenantConstraint {
		const loConstraint = this.getConstraint(
			IntervenantConstraint,
			poResponse,
			poStartSeance,
			pdEnd
		);

		loConstraint.intervenantIds = paNewIntervenants.map((poIntervenant: IGroupMember | string) =>
			typeof poIntervenant === "string" ? poIntervenant : poIntervenant._id
		);

		return loConstraint;
	}

	/** Créé les documents de facturation pour chaque séance.
	 * @param poSeance Séance à facturer.
	 */
	public createSeancePrestation(traitement: Traitement, seance: Seance, observation?: string, tarification?: boolean): IdlPrestation {
		const prestationLines: IIdlPrestationLine[] = [];

		seance.actes.forEach((acte: Acte) => {
			prestationLines.push(this.createPrestationLineFromActe(acte, seance.label, traitement._id));
		});

		seance.majorations?.forEach((majoration: Majoration) => {
			if (!majoration.disabled)
				prestationLines.push(this.createPrestationLineFromMajoration(majoration, seance.label, traitement._id));
		});

		seance.indemnites?.forEach((indemnite: Indemnite) => {
			if (!indemnite.disabled)
				prestationLines.push(this.createPrestationLineFromIndemnite(traitement, indemnite, seance.label, traitement._id));
		});

		const currentDate = new Date();
		return new IdlPrestation({
			_id: this.svcPrestation.buildId({ traitementId: seance.traitementId, customerIdOrPrefix: Traitement.extractPatientId(seance.traitementId), prestationDate: DateHelper.toUTCString(seance.startDate, EUTCAccuracy.minutes) } as IIdlPrestationIdBuilderParams),
			originalLines: prestationLines,
			lines: prestationLines,
			originalStatus: seance.status === EStatusSeance.canceled ? EPrestationStatus.canceled : EPrestationStatus.created,
			status: seance.status === EStatusSeance.canceled ? EPrestationStatus.canceled : EPrestationStatus.created,
			originalVendorId: ContactsService.getUserContactId(),
			vendorId: ContactsService.getUserContactId(),
			authorId: seance.infirmierId,
			createDate: currentDate,
			lastUpdateDate: currentDate,
			place: seance.place,
			observation: observation,
			seanceId: seance._id,
			...(tarification ? { tarification } : {})
		});
	}

	public createPrestationLineFromActe(poActe: Acte, psSeanceLabel: string, psOrdonnanceId: string = ""): IdlPrestationLine {
		return new IdlPrestationLine({
			ref: poActe._id,
			price: +NumberHelper.round(poActe.initialPrice * poActe.priceCoefficient, 2),
			discountRate: Math.abs(1 - ((poActe.isAbattementForced) ? poActe.taxAllowanceForced : poActe.taxAllowance)),
			extraCharge: poActe.extraCharge,
			description: poActe.description,
			category: EIdlPrestationLineCategory.actes,
			group: psSeanceLabel,
			coefficient: poActe.priceCoefficient,
			lettreCle: poActe.keyLetters,
			ordonnanceId: psOrdonnanceId,
			isAldExonerante: poActe.isAldExonerante
		});
	}

	public createPrestationLineFromMajoration(poMajoration: Majoration, psSeanceLabel: string, psOrdonnanceId: string = ""): IdlPrestationLine {
		return new IdlPrestationLine({
			ref: poMajoration.type,
			lettreCle: poMajoration.type,
			price: poMajoration.price,
			description: poMajoration.description,
			category: EIdlPrestationLineCategory.majorations,
			group: psSeanceLabel,
			ordonnanceId: psOrdonnanceId
		});
	}

	public createPrestationLineFromIndemnite(poTraitement: Traitement, poIndemnite: Indemnite, psSeanceLabel: string, psOrdonnanceId: string = ""): IdlPrestationLine {
		let deplacement: Deplacement = new Deplacement();
		deplacement.distance = poIndemnite.distance;
		deplacement.isManualPrice = false;
		deplacement.sectorType = this.isvcIndemnite.getSecteur(poIndemnite.type);
		let isIKType: Boolean = poIndemnite.type === EIndemniteType.IK || poIndemnite.type === EIndemniteType.IKM || poIndemnite.type === EIndemniteType.IKS;
		const lnDistance: number = isIKType ? this.isvcIndemnite.calculateAbattementDistance(deplacement) : 1;

		return new IdlPrestationLine({
			ref: poIndemnite.type,
			lettreCle: poIndemnite.type,
			price: +NumberHelper.round(poIndemnite.price / lnDistance, 2),
			quantity: lnDistance,
			description: poIndemnite.description,
			category: EIdlPrestationLineCategory.indemnites,
			group: psSeanceLabel,
			ordonnanceId: psOrdonnanceId
		});
	}
}
